import { useCustomQuery } from './apollo/ApolloCustomHooks';
import { IPermission } from '../interfaces/permission';
import { IRole } from '../interfaces/role';
import { ITenant } from '../interfaces';
import { Query } from '../services/graphql/query';

const emptyRoles: IRole[] = [];
const emptyPermissions: IPermission[] = [];
const emptyTenants: ITenant[] = [];

function isCurrentTenant(
  variables: Record<string, unknown> | undefined,
  tenantId: number | undefined,
) {
  return tenantId != null && variables?.tenant_id === tenantId;
}

/** Reference lists loaded with the current tenant, outside mount effects. */
export function useTenantRoles(tenantId: number | undefined) {
  const query = useCustomQuery<{ roles: IRole[] }>(Query.roles, {
    variables: { tenant_id: tenantId },
    skip: tenantId == null,
    fetchPolicy: 'no-cache',
  });

  return {
    ...query,
    roles: isCurrentTenant(query.variables, tenantId)
      ? (query.data?.roles ?? emptyRoles)
      : emptyRoles,
  };
}

export function useTenantPermissions(tenantId: number | undefined) {
  const query = useCustomQuery<{ permissions: IPermission[] }>(
    Query.permissions,
    {
      variables: { tenant_id: tenantId },
      skip: tenantId == null,
      fetchPolicy: 'no-cache',
    },
  );

  return {
    ...query,
    permissions: isCurrentTenant(query.variables, tenantId)
      ? (query.data?.permissions ?? emptyPermissions)
      : emptyPermissions,
  };
}

export function useTenantOptions(tenantId: number | undefined) {
  const query = useCustomQuery<{ tenants: ITenant[] }>(Query.tenants, {
    variables: { tenant_id: tenantId },
    skip: tenantId == null,
    fetchPolicy: 'no-cache',
  });

  return {
    ...query,
    tenants: isCurrentTenant(query.variables, tenantId)
      ? (query.data?.tenants ?? emptyTenants)
      : emptyTenants,
  };
}
